<template>
  <div class="circle" :class="size"></div>
</template>

<script>
export default {
  name: 'RedCircle',

  props: {
    size: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">

.circle {
  width: 30px;
  height: 30px;
  background-color: $c-red;
  border-radius: 50%;
  margin: auto;
  display: inline-block;
  vertical-align: middle;

  @include breakpoint('sm-and-up') {
    width: 12px;
    height: 12px;
  }

  &.large {
    @include breakpoint('sm-and-up') {
      width: 60px;
      height: 60px;
    }
  }

  &.small {
    width: 5px;
    height: 5px;

    @include breakpoint('sm-and-up') {
      width: 10px;
      height: 10px;
    }
  }
}
</style>
